import React, { FC } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import MessagesIndexAreaContainer from 'buyside/components/container/MessagesIndex/MessagesIndexAreaContainer';
import MessagesIndexNav from 'buyside/components/presentation/MessagesIndexPage/MessagesIndexNav/messagesIndexNav';
import MessagesThreadIndexContainer from 'buyside/components/container/MessageThreadIndex/MessageThreadIndexContainer';
import NewMessageFormPage from 'buyside/components/presentation/MessagesIndexPage/NewMessageForm/newMessageFormPage';

import { messagesUrl } from 'buyside/util/urlHelper';

const MessagesIndexPageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="the messages index page">
      <BrowserRouter basename={messagesUrl()}>
        <MessagesIndexNav />
        <Routes>
          <Route path="/" element={<MessagesIndexAreaContainer mailbox="inbox" />} />
          <Route path="/unread" element={<MessagesIndexAreaContainer mailbox="unread" />} />
          <Route path="/read" element={<MessagesIndexAreaContainer mailbox="read" />} />
          <Route path="/archive" element={<MessagesIndexAreaContainer mailbox="archive" />} />
          <Route path="/new/:encodedPayload?" element={<NewMessageFormPage />} />
          <Route path="/:thread" element={<MessagesThreadIndexContainer />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default MessagesIndexPageRoot;
